import type { CustomReportResponse } from '../../api';

import { useReportParameter } from './useReportParameter';
import { useCustomReportQuery } from '../../api';
import { useReportStore } from '../../stores';

// const isLoadingData = (key: string, cacheData: IReportDataCache) => {
//   return !cacheData[key] || typeof cacheData[key]?.data === 'undefined';
// };

// const getCachedData = (key: string, cacheData: IReportDataCache) => {
//   return deepCopy(cacheData[key]?.data) ?? {};
// };

export const useFetchReport = () => {
  const { parameter, parameterKey, enabled } = useReportParameter();

  // const cacheData = useReportStore((state) => state.cacheData);
  const upsertCacheData = useReportStore((state) => state.upsertCacheData);

  // const data = useMemo(() => getCachedData(parameterKey, cacheData), [cacheData, parameterKey]);
  // const isLoading = useMemo(
  //   () => isLoadingData(parameterKey, cacheData),
  //   [cacheData, parameterKey],
  // );

  const handleSuccess = (response: CustomReportResponse, cacheKey: string) => {
    const xRequestId = response?.headers['x-request-id'];
    upsertCacheData(cacheKey, {
      requestId: xRequestId ?? '',
      data: response?.gemxQLQuery ?? [],
    });
  };

  const { refetch, isFetching, data } = useCustomReportQuery(parameter, {
    enabled,
    retry: 0,
    onSuccess: (response) => handleSuccess(response, parameterKey),
    onSettled(response, error) {
      if (error) {
        const xRequestId = response?.headers['x-request-id'];
        upsertCacheData(parameterKey, { requestId: xRequestId ?? '' });
      }
    },
    keepPreviousData: true,
  });

  return {
    data: data?.gemxQLQuery,
    isLoading: isFetching,
    refetch,
  };
};
